import marketpleacesBrandService from "../../services/marketpleacesBrandService";
import {
      MARKETPLACESBRAND_ADD_REQUEST,
      MARKETPLACESBRAND_ADD_FAILURE,
      MARKETPLACESBRAND_ADD_SUCCESS,
      MARKETPLACESBRAND_DELETE_REQUEST,
      MARKETPLACESBRAND_DELETE_FAILURE,
      MARKETPLACESBRAND_DELETE_SUCCESS,
      MARKETPLACESBRAND_GET_REQUEST,
      MARKETPLACESBRAND_GET_FAILURE,
      MARKETPLACESBRAND_GET_SUCCESS
     } from "./actionTypes";

export const fetchMarketPlaceBrand = () => {
  return async (dispatch) => {
    dispatch({ type: MARKETPLACESBRAND_GET_REQUEST });
    try {
      const response = await marketpleacesBrandService.fetchMarketPlaceBrand();
      const { data } = response;
      dispatch({ type: MARKETPLACESBRAND_GET_SUCCESS, payload: data });
      return data; 
    } catch (error) {
      dispatch({ type: MARKETPLACESBRAND_GET_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};

  export const addMarketPlaceBrand = (brqandData,token) => {
    return async (dispatch) => {
      dispatch({ type: MARKETPLACESBRAND_ADD_REQUEST });
      try {
        const response = await marketpleacesBrandService.addMarketPlaceBrand(brqandData,token);
        const { data } = response;
        dispatch({ type: MARKETPLACESBRAND_ADD_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: MARKETPLACESBRAND_ADD_FAILURE, error: error.message });
        return Promise.reject(error); 
      }
    };
  };


  export const deleteMarketPlaceBrand = (id,token) => {
    return async (dispatch) => {
      dispatch({ type: MARKETPLACESBRAND_DELETE_REQUEST });
      try {
        const response = await marketpleacesBrandService.deleteMarketPlaceBrand(id,token);
        const { data } = response;
        dispatch({ type: MARKETPLACESBRAND_DELETE_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: MARKETPLACESBRAND_DELETE_FAILURE, error: error.message });
        return Promise.reject(error); 
      }
    };
  };

